import { ILegalViewService } from "../service/LegalViewService";

export default class RevertLegalViewStatusInteractor {
  private legalViewService: ILegalViewService;

  constructor({ legalViewService }: any) {
    this.legalViewService = legalViewService;
  }

  async execute(legalViewId: number) {
    return this.legalViewService.revertLegalViewStatus(legalViewId);
  }
}
